import { render, staticRenderFns } from "./productlabelAuto.vue?vue&type=template&id=0c54b4cc&scoped=true"
import script from "./productlabelAuto.vue?vue&type=script&lang=js"
export * from "./productlabelAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54b4cc",
  null
  
)

export default component.exports